import { Logo, Wrapper } from './sign-up-velory.aside-style';

export const SignUpVeloryAside = () => (
  <Wrapper>
    <Logo />
  </Wrapper>
);
